<!--
Copyright 2025 Carnegie Mellon University. All Rights Reserved.
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="d-flex gap-5 justify-content-center">
  <app-admin-evaluation-membership-list [users]="nonMembers$ | async" [groups]="groupNonMembers$ | async"
    [canEdit]="canEdit" (createMembership)="createMembership($event)"></app-admin-evaluation-membership-list>

  <app-admin-evaluation-member-list [memberships]="memberships$ | async" [users]="members$ | async"
    [groups]="groupMembers$ | async" [roles]="roles$ | async" [canEdit]="canEdit"
    (deleteMembership)="deleteMembership($event)" (editMembership)="editMembership($event)"></app-admin-evaluation-member-list>
</div>
